import { STATION_PLACES } from "@/config/search-places/stations-kr.generated";
import { DESTINATION_ALIASES } from "@/config/search-places/destination-aliases.generated";
import { registerDestinationAliases, registerStationPlaces } from "./place-resolver";

/**
 * 역 사전·여행지 별칭을 즉시 등록한다 — import 만 하면 된다(부수 효과 모듈).
 * 서버(검색 데이터·관련 가이드)와 검색 페이지 클라이언트처럼 첫 렌더부터 역 이름을
 * 해석해야 하는 곳에서 쓴다. 공용 번들(Navbar 경로)에서는 import 하지 말 것 —
 * 대신 `ensureStationPlaces()`(지연 로드).
 */
registerDestinationAliases(DESTINATION_ALIASES);
registerStationPlaces(STATION_PLACES);

